import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/elite-feats-cms/components/typographyStyle";

const useStyles = makeStyles(styles);

interface MutedProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "color"> {
  children?: React.ReactNode;
}

export default function Muted(props: MutedProps): React.ReactElement {
  const classes = useStyles();
  const { children } = props;
  return (
    <div className={classes.defaultFontStyle + " " + classes.mutedText}>
      {children}
    </div>
  );
}

